var map = {
	"./css.jpg": 432,
	"./freelancer.jpg": 350,
	"./frontend-freecodecamp.png": 414,
	"./icpc2021.jpg": 772,
	"./icpc2021x.jpg": 47,
	"./icpc2022.jpg": 40,
	"./icpc2022x.jpg": 778,
	"./javascript-freecodecamp.png": 393,
	"./javascript.jpg": 856,
	"./responsive-freecodecamp.png": 404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;